{
  "CONTACTS_FILTER": {
    "TITLE": "篩選聯絡人",
    "SUBTITLE": "新增以下篩選條件並點選「送出」以篩選聯絡人。",
    "EDIT_CUSTOM_SEGMENT": "編輯區段",
    "CUSTOM_VIEWS_SUBTITLE": "新增或移除篩選條件並更新您的區段。",
    "ADD_NEW_FILTER": "新增篩選條件",
    "CLEAR_ALL_FILTERS": "清除所有篩選條件",
    "FILTER_DELETE_ERROR": "至少需要一個篩選條件才能儲存",
    "SUBMIT_BUTTON_LABEL": "送出",
    "UPDATE_BUTTON_LABEL": "更新區段",
    "CANCEL_BUTTON_LABEL": "取消",
    "CLEAR_BUTTON_LABEL": "清除篩選條件",
    "EMPTY_VALUE_ERROR": "值為必填",
    "SEGMENT_LABEL": "區段名稱",
    "SEGMENT_QUERY_LABEL": "區段查詢",
    "TOOLTIP_LABEL": "篩選聯絡人",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "且",
      "OR": "或"
    },
    "OPERATOR_LABELS": {
      "equal_to": "等於",
      "not_equal_to": "不等於",
      "contains": "包含",
      "does_not_contain": "不包含",
      "is_present": "存在",
      "is_not_present": "不存在",
      "is_greater_than": "大於",
      "is_lesser_than": "小於",
      "days_before": "x 天前"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "值為必填"
    },
    "ATTRIBUTES": {
      "NAME": "姓名",
      "EMAIL": "電子郵件",
      "PHONE_NUMBER": "電話號碼",
      "IDENTIFIER": "識別碼",
      "CITY": "城市",
      "COUNTRY": "國家",
      "CUSTOM_ATTRIBUTE_LIST": "列表",
      "CUSTOM_ATTRIBUTE_TEXT": "文字",
      "CUSTOM_ATTRIBUTE_NUMBER": "數字",
      "CUSTOM_ATTRIBUTE_LINK": "連結",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "核取方塊",
      "CREATED_AT": "建立時間",
      "LAST_ACTIVITY": "最後活動",
      "REFERER_LINK": "來源連結",
      "BLOCKED": "已封鎖",
      "LABELS": "標籤"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "標準篩選條件",
      "ADDITIONAL_FILTERS": "進階篩選條件",
      "CUSTOM_ATTRIBUTES": "自訂屬性"
    }
  }
}
